import { Link } from "react-router-dom";

const LOGO_SRC = "/autocarex-logo.png";

export const Logo = ({ className = "", size = "md" }) => {
  const h = size === "lg" ? "h-9 sm:h-11" : size === "sm" ? "h-6" : "h-7 sm:h-8";
  return (
    <Link to="/" data-testid="header-logo" className={`inline-flex items-center ${className}`}>
      <img
        src={LOGO_SRC}
        alt="AutoCareX — Intelligent Car Care"
        className={`${h} w-auto object-contain`}
        draggable="false"
      />
    </Link>
  );
};

export default Logo;
